/**
 * @fileoverview Agent definition for storyline-extraction-pipeline-v1.
 *
 * Composite agent that orchestrates the split storyline extraction pipeline:
 * A-Story (main) → B-Stories (parallel with C) → C-Stories (parallel with B).
 *
 * Orchestrates A → B → C sequential extraction where B/C agents
 * use the A-Story as context for higher-quality results.
 *
 * @category import.story.extraction
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'storyline-extraction-pipeline-v1',
  kind: 'composite',
  name: 'Storyline Extraction Pipeline',
  description: 'Extracts A/B/C storylines via split pipeline: A-Story first, then B+C in parallel using A as context.',
  category: 'import',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: [
      'use-storyline-extraction-pipeline-v1.ts',
    ],
    composedOf: [
      'a-storyline-extractor-v1',
      'b-storyline-extractor-v1',
      'c-storyline-extractor-v1',
    ],
    relatedAgents: [],
  },
};
